module.exports = __webpack_public_path__ + "img/courthouse.48b8a4ef.svg";